import styled from "@emotion/styled";

export const TrackPercentageBlock = styled.div`
  padding-block-start: 1px;
`;
